import { jsxs as x, jsx as e } from "react/jsx-runtime";
import { a as I } from "../../core-DVmjA3_O.js";
import { _ as h } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import L from "../Description/index.js";
import A from "../InlineLayout/index.js";
import q from "../InputError/index.js";
import D from "../InputLabel/index.js";
import P from "../Label/index.js";
import T from "../ListView/index.js";
import U from "../../hooks/useSpacingToken.js";
import '../../index32.css';const j = "_input-container_1bo86_1", B = "_input-section_1bo86_4", z = "_general-variant_1bo86_11", E = "_disabled_1bo86_18", M = "_with-update-highlight_1bo86_26", F = "_form-variant_1bo86_27", G = "_transparent-variant_1bo86_28", J = "_with-add-highlight_1bo86_36", K = "_with-remove-highlight_1bo86_46", Q = "_errored_1bo86_61", W = "_read-only_1bo86_67", t = {
  inputContainer: j,
  inputSection: B,
  generalVariant: z,
  disabled: E,
  withUpdateHighlight: M,
  formVariant: F,
  transparentVariant: G,
  withAddHighlight: J,
  withRemoveHighlight: K,
  errored: Q,
  readOnly: W
};
function st(p) {
  const {
    containerRef: c,
    inputSectionRef: g,
    actions: m,
    className: _,
    disabled: a,
    error: i,
    errorOnTooltip: o = !1,
    hint: l,
    icons: f,
    input: u,
    label: b,
    labelClassName: w,
    readOnly: v,
    required: V,
    variant: r = "form",
    withAsterisk: y,
    spacing: s,
    prevValue: d,
    withPrevValue: H,
    highlightMode: n,
    withPadding: R,
    withBackground: O,
    withDarkBackground: S,
    withoutInputSectionPadding: k
  } = p, C = y ?? V, N = U({
    spacing: s,
    offset: r === "transparent" ? -2 : -3,
    modes: k ? [] : ["padding-inline"]
  });
  return /* @__PURE__ */ x(
    T,
    {
      elementRef: c,
      layout: "block",
      className: h(
        t.inputContainer,
        !!i && t.errored,
        v && t.readOnly,
        r === "form" && t.formVariant,
        r === "general" && t.generalVariant,
        r === "transparent" && t.transparentVariant,
        a && t.disabled,
        n === "add" && t.withAddHighlight,
        n === "update" && t.withUpdateHighlight,
        n === "remove" && t.withRemoveHighlight,
        _
      ),
      title: o && i && typeof i == "string" ? i : void 0,
      spacing: s,
      spacingOffset: -4,
      withBackground: O,
      withDarkBackground: S,
      withPadding: R,
      children: [
        /* @__PURE__ */ e(
          D,
          {
            className: w,
            disabled: a,
            required: C,
            children: b
          }
        ),
        /* @__PURE__ */ e(
          A,
          {
            className: h(
              t.inputSection,
              N
            ),
            elementRef: g,
            before: f,
            after: m,
            spacingOffset: -3,
            spacing: s,
            children: u
          }
        ),
        H && d && I(n) && /* @__PURE__ */ e(P, { strong: !0, children: d }),
        !i && !o && l && /* @__PURE__ */ e(
          L,
          {
            withLightText: !0,
            textSize: "sm",
            children: l
          }
        ),
        i && /* @__PURE__ */ e(
          q,
          {
            disabled: a,
            floating: o,
            children: i
          }
        )
      ]
    }
  );
}
export {
  st as default
};
